import $localStorage from "@/utils/localStorage";
import { xxUrlParams } from "@/utils/getUrlParam";

const xxUserInfo = $localStorage.get("xxUserInfo") || {};
export default {
	data() {
		return {
			openid: xxUserInfo.openid,
			user_id: xxUserInfo.user_id,
			xxUrlParams,
		};
	},
	methods: {
		wxLogin() {
			let redirectUrl = encodeURIComponent(window.location.href);
			let url = encodeURIComponent(
				`${window.location.origin}/wxLogin.html?redirectUrl=${redirectUrl}`,
			);
			window.location.replace(`http://xxfoodweixin.xun-ao.com/auth?url=${url}`);
		},
	},
};
